import React from 'react';

interface PageHeaderProps {
  title: string;
  count?: number;
  description?: string;
  children?: React.ReactNode;
}

/** A tab's title, with its item count beside it (outside the heading) and its actions on the right */
const PageHeader: React.FC<PageHeaderProps> = ({ title, count, description, children }) => (
  <div className="page-header">
    <div>
      <div className="page-header-title">
        <h2>{title}</h2>
        {count !== undefined && <span className="page-header-count">{count}</span>}
      </div>
      {description && <p className="page-header-description">{description}</p>}
    </div>
    {children && <div className="page-header-actions">{children}</div>}
  </div>
);

export default PageHeader;
